export default __webpack_public_path__ + "static/media/1.cc7ade86.png";